import { inject } from "aurelia-framework";
import { ValidationRules } from "aurelia-validation";
import { LocaleService } from "../services/locale-service";

@inject(LocaleService)
export class CustomValidationRules {
  constructor(private localeService: LocaleService) {}

  init(): void {
    ValidationRules.customRule(
      "float",
      (value) => !value || this.localeService.isFloat(value),
      `\${$displayName} must be a number`,
    );

    ValidationRules.customRule(
      "int",
      (value) => !value || this.localeService.isInt(value),
      `\${$displayName} must be a number`,
    );

    ValidationRules.customRule(
      "positive",
      (value) =>
        !value ||
        (this.localeService.isFloat(value) &&
          this.localeService.parseFloat(value) > 0),
      `\${$displayName} must be a positive number`,
    );

    ValidationRules.customRule(
      "min",
      (value, obj, min) =>
        !value ||
        (this.localeService.isFloat(value) &&
          this.localeService.parseFloat(value) >= min),
      `\${$displayName} must be greater than or equal to \${$config.min}`,
      (min) => ({ min: min }),
    );

    ValidationRules.customRule(
      "max",
      (value, obj, max) =>
        !value ||
        (this.localeService.isFloat(value) &&
          this.localeService.parseFloat(value) <= max),
      `\${$displayName} must be lower than or equal to \${$config.max}`,
      (max) => ({ max: max }),
    );
  }
}
